import Vue from 'vue';
import Router from 'vue-router';
import StatusPhotosMain from '@/components/StatusPhotosMain';
import Login from '@/components/login';
import NotFound from '@/components/status_code/404';
import store from '../store';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    console.log(!store.getters.isAuthenticated);
    next();
    return;
  }
  next('/status-photos');
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    console.log(store.getters.isAuthenticated);
    next();
    return;
  }
  next('/login');
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/status-photos',
      name: 'StatusPhotosMain',
      beforeEnter: ifAuthenticated,
      component: StatusPhotosMain,

    },
    {
      path: '/login',
      name: 'Login',
      beforeEnter: ifNotAuthenticated,
      component: Login,
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      path: '/',
      redirect: '/status-photos',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js